import {
  prepareBody,
  prepareBodyWithoutId,
  prepareParams,
} from "../../utils/api_params";
export const configApi = (api) =>
  api.injectEndpoints({
    endpoints: (build) => ({}),
  });
